<div class="sidenav-content">
	<div class="card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<span class="card-title-label" translate>menu.order-services</span>
	</div>
	<copo-ecall-off-widget [canCallByVolume]="canCallByVolume"></copo-ecall-off-widget>
</div>
